import {EScene} from '@/types/scene.types'
import {useAtomValue} from 'jotai'
import {useEffect} from 'react'
import {useTransitionState} from 'react-transition-state'
import {sceneState} from '../Store/atoms'
import {Minimap} from './Minimap'

export const MinimapScreen = () => {
  const scene = useAtomValue(sceneState)

  const [state, toggle] = useTransitionState({
    timeout: {
      enter: 0,
      exit: 2000, // <-- time allowed for the exit animation
    },
  })

  /**
   * If the scene is pre-lobby, toggle the transition
   */
  useEffect(() => {
    if (scene === EScene.STARTED) {
      toggle(true)
    } else {
      toggle(false)
    }
  }, [scene])

  /**
   * If the status is exited, don't render anything
   */
  if (state.status === 'exited') {
    return null
  }

  return <Minimap transitionStatus={state.status} />
}
